export let endPointPublic = 'http://api.webrep.gosales.com.br/api/public/'
export let endPointPrivate = 'http://api.webrep.gosales.com.br/api/private/'
// export let endPointPublic = 'http://192.168.100.45:8085/api/public/'
// export let endPointPrivate = 'http://192.168.100.45:8085/api/private/'



// WEBPACK FOOTER //
// ./src/services/config.js